// @ts-nocheck

// App
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useYieldCallback } from '@zillow/yield-callback';

// Hooks
import { useFilterChange } from 'app/shared/modules/filter/FilterBar/hooks';

// Misc / utils
import {
  GeneralApplyFilterButton,
  GeneralFilterHeader,
  GeneralFilterLabel,
} from 'app/shared/modules/filter/FilterBar/styles';
import * as S from './styles';

const InfoCardPriceSlider = () => {
  // Redux
  const priceState = useSelector((state) => state.filter.price);

  // React state
  const [filterState, setFilterState] = useState(priceState);
  const [isComponentLoaded, setIsComponentLoaded] = useState(false);
  const [sliderValue, setSliderValue] = useState([
    filterState.min ? filterState.min / 100 : 0,
    filterState.max ? filterState.max / 100 : 50,
  ]);

  // Hooks
  const { filterChange, isFilterResetting } = useFilterChange();

  const HUNDRED_TO_ONE_SCALE = 100;
  const shouldShowApplyButton = sliderValue[0] !== 0 || sliderValue[1] !== 50;

  const handleSliderOnChange = (valArr) => {
    setSliderValue(valArr);
  };

  const yieldTrackFilterChange = useYieldCallback((formattedVals) => {
    filterChange({ price: { min: formattedVals.min, max: formattedVals.max } });
  });

  const handleFilterApply = () => {
    const [min, max] = sliderValue;
    const formattedVals = {
      min: min === 0 ? null : min * HUNDRED_TO_ONE_SCALE,
      max: max === 50 ? null : max * HUNDRED_TO_ONE_SCALE,
    };

    yieldTrackFilterChange(formattedVals);
  };

  useEffect(() => {
    if (!isComponentLoaded) {
      setIsComponentLoaded(true);
    } else {
      if (!isFilterResetting) {
        filterChange({ price: filterState });
      }
    }
  }, [filterState]);

  const Thumb = (props, state) => {
    const { key, ...restProps } = props;
    return (
      <S.SliderThumb key={`thumb-${state.index}`} {...restProps}>
        {'| |'}
      </S.SliderThumb>
    );
  };
  const Track = (props, state) => {
    const { key, ...restProps } = props;
    return <S.SliderTrack key={`track-${state.index}`} {...restProps} index={state.index} />;
  };
  const getDisplayText = (valArr) => {
    const minVal = valArr[0];
    const maxVal = valArr[1];
    const isAtMin = minVal === 0;
    const isAtMax = maxVal === 50;

    if (isAtMin && isAtMax) {
      return 'Any price';
    }

    if (isAtMin && !isAtMax) {
      return `Less than ${maxVal * HUNDRED_TO_ONE_SCALE}`;
    }

    if (!isAtMin && isAtMax) {
      return `More than ${minVal * HUNDRED_TO_ONE_SCALE}`;
    }

    if (!isAtMin && !isAtMax) {
      return `From ${minVal * HUNDRED_TO_ONE_SCALE} to ${maxVal * HUNDRED_TO_ONE_SCALE}`;
    }
  };

  return (
    <>
      <GeneralFilterHeader>
        <GeneralFilterLabel id="price-info-card-label">Price range</GeneralFilterLabel>
        {shouldShowApplyButton && (
          <GeneralApplyFilterButton onClick={handleFilterApply} aria-label={'Apply price filter'}>
            Apply
          </GeneralApplyFilterButton>
        )}
      </GeneralFilterHeader>
      <S.DisplayText>{getDisplayText(sliderValue)}</S.DisplayText>
      <S.InfoCardPriceSlider
        aria-labelledby="price-info-card-label"
        ariaLabel={['Minimum price thumb', 'Maximum price thumb']}
        ariaValuetext={(state) =>
          `Current ${state.index === 0 ? 'min' : 'max'} value: ${
            state.valueNow === 0 ? 'No minimum' : `${state.valueNow * 100} dollars`
          }`
        }
        min={0} // 1:100 scale
        max={50} // 1:100 scale
        value={sliderValue} // 1:100 scale
        onChange={handleSliderOnChange}
        renderTrack={Track}
        renderThumb={Thumb}
      />
    </>
  );
};

export default InfoCardPriceSlider;
